export default {
      id: "empty-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#empty",
      toString: function () {
        return this.url;
      }
    }